import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row, Form } from "react-bootstrap";

import TableComponentPage4 from "../Table/GroupTable";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import Select from 'react-select'
import ReactExport from "react-data-export";
import { CSVLink, CSVDownload } from "react-csv";
function MediaList() {
  const columns = React.useMemo(
    () => [
      {
        Header: "Media ID",
        accessor: "id", // accessor is the "key" in the data
      },
      {
        Header: "Media name",
        accessor: "name",
      },
      {
        Header: "Language",
        accessor: "language",
      },
      {
        Header: "Media type",
        accessor: "type",
      },
      {
        Header: "Add on",
        accessor: "createdAt",
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) => (
          <span >
            {value === 1 ? "Active" : "Inactive"}
          </span>
        ),
      },
      {
        Header: "Preview",
        accessor: "preview",
        Cell : ({ row }) => {
          return (
            <img width="60" src={row.original.preview}></img>
          )
        }
      },
      {
        Header: "Size",
        accessor: "size",
      }
    ],
    []
  );
  const [currentPage, setCurrentPage] = useState(1)
  const [mediaPages, setMediaPages] = useState(1)
  const [selectedRows, setSelectedRows] = useState([])
  const [loadingMedia, setLoadingMedia] = useState(false)
  const [medias, setMedias] = useState([])
  const [resetTable, setResetTable] = useState(false);
  const [ltCampGrp, setLtCampGrp] = useState([])
  const [ltMediaType, setLtMediaType] = useState([])
  const [ltLang, setLtLang] = useState([])
  const [MediaStatus, setMediaStatus] = useState({
    status: 0
  })
  const [mediaFilter, setMediaFilter] = useState({
    filters: {
      mediaid: "",
      language: "",
      campaignname: "",
      width: "",
      height: "",
      mediatype: "",
      campaign: "",
      medianame: ""
    }
  })
  const getMediaList = async () => {
    setLoadingMedia(true)
    const response = await axios.post(window.__CFG.API + "marketing/ListMedia?page=" + currentPage, mediaFilter, {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    setLoadingMedia(false)
    if (response.data.Error == null) {
      setMedias(response.data.Result.Data)
      setMediaPages(response.data.Pages)
    }
    else {
      setMedias([])
    }
  }
  const changeMediaStatus = async () => {
    if (selectedRows.length > 0) {
      selectedRows.forEach(async sr => {
        const response = await axios.post(window.__CFG.API + "marketing/ChangeMediaStatus/" + sr.id, MediaStatus, {
          headers: {
            "Authorization": "Bearer " + localStorage.getItem("raff-token")
          }
        })
        if (response.data.Error == null) {
          toast.success("Saved Sucessufully", {
            duration: 4000
          });
          getMediaList()
          setSelectedRows([]);
          setResetTable(!resetTable);
        }
        else {
          toast.error(response.data.Error, {
            duration: 4000
          })
        }
      })
    }
    else {
      toast.error("Please select a row", {
        duration: 4000
      })
    }
  }
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleSelectedRowsChange = (selectedRows) => {
    setSelectedRows(selectedRows);
  }
  useEffect(() => { getMediaList() }, [currentPage])
  const getListCompaigns = async () => {
    const response = await axios.get(window.__CFG.API + "manager/ListAllCampaigns", {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    if (response.data.Error === null) {
      setLtCampGrp(response.data.Result)
    }
  }
  const getListMediaType = async () => {
    const response = await axios.get(window.__CFG.API + "manager/ListAllMediaTypes", {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    if (response.data.Error === null) {
      setLtMediaType(response.data.Result)
    }
  }
  const getListLanguages = async () => {
    const response = await axios.get(window.__CFG.API + "manager/ListAllLanguages", {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    if (response.data.Error === null) {
      setLtLang(response.data.Result)
    }
  }
  useEffect(() => { getListCompaigns(); getListMediaType(); getListLanguages() }, [])
  const statusOptions = [{ label: "Activate", value: 1 }, { label: "Desactivate", value: 0 }]
  return (
    <>
      <Container>
        <Row>
          <Col>


            <h4 className="text-start mt-5">Media List </h4>

            <Row className="justify-content-between  mt-4 me-auto w-100">
              <Col lg={6} md={4} sm={5}>
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                    <label>Media id </label>
                  </div>
                  <div className="form-cre-grp-fl-wp-in">
                    <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type="text" value={mediaFilter.filters.mediaid} onChange={e => { setMediaFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, mediaid: e.target.value } })) }} />
                  </div>
                </div>
              </Col>
              <Col lg={6} md={4} sm={4}>
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                    <label>size </label>
                  </div>
                  <div className="form-cre-grp-fl-wp-in">
                    <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)", marginLeft: 0, textAlign: "center" }} type="text" placeholder="width" value={mediaFilter.filters.width} onChange={e => { setMediaFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, width: e.target.value } })) }} />
                  </div>
                  <div style={{ padding: 5, marginLeft: 5 }}>
                    X
                  </div>
                  <div className="form-cre-grp-fl-wp-in">
                    <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)", textAlign: "center" }} type="text" placeholder="height" value={mediaFilter.filters.height} onChange={e => { setMediaFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, height: e.target.value } })) }} />
                  </div>
                </div>

              </Col>
            </Row>

            <Row className="justify-content-between  mt-2  me-auto w-100">

              <Col lg={6} md={4} sm={5}>
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                    <label>Media name </label>
                  </div>
                  <div className="form-cre-grp-fl-wp-in">
                    <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type="text" value={mediaFilter.filters.medianame} onChange={e => { setMediaFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, medianame: e.target.value } })) }} />
                  </div>
                </div>
              </Col>
              <Col lg={6} md={4} sm={4}>
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                    <label>Media type </label>
                  </div>
                  <div className="form-cre-grp-fl-wp-in">

                    <Select options={ltMediaType} onChange={e => { setMediaFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, mediatype: e.value } })) }} />

                  </div>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-between  mt-2 me-auto w-100">

              <Col lg={6} md={4} sm={4}>
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                    <label>Campaign </label>
                  </div>
                  <div className="form-cre-grp-fl-wp-in">
                    <Select options={ltCampGrp} onChange={e => { setMediaFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, campaign: e.value } })) }} />

                  </div>
                </div>
              </Col>
              <Col lg={6} md={4} sm={4}>
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                    <label>campaign name </label>
                  </div>
                  <div className="form-cre-grp-fl-wp-in">
                    <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type="text" value={mediaFilter.filters.campaignname} onChange={e => { setMediaFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, campaignname: e.target.value } })) }} />
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-between  mt-2 me-auto w-100">

              <Col lg={6} md={4} sm={4}>
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                    <label>language </label>
                  </div>
                  <div className="form-cre-grp-fl-wp-in">
                    <Select options={ltLang} onChange={e => { setMediaFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, language: e.value } })) }} />
                  </div>
                </div>
              </Col>
              <Col lg={6} md={4} sm={4} className=" pt-2 md-se-btn btn-wrap-comp">
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                  </div>
                  <div className="form-cre-grp-fl-wp-in md-se-btn">
                    <Button onClick={getMediaList} className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp">
                      Search
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>



            <div style={{ borderBottom: "1px dashed black", marginTop: "30px", width: "100%" }}></div>



            <Row className="mt-3 mb-4">
              <div className="aff-dash-summary-table">
                <TableComponentPage4 key={resetTable} columns={columns} data={medias} Pages={mediaPages} currentPage={currentPage} loading={loadingMedia} onSelectedRowsChange={handleSelectedRowsChange} onPageChange={handlePageChange} linkColumn="id" linkUrl="/affiliate/marketing/media/details?id=" />
              </div>
            </Row>

            <Row className="justify-content-start  mt-2  w-100 mb-5">
              <div style={{ display: "flex", alignItems: "center" }}>
                <div>
                  <div className="form-cre-grp-fl-wp-in">
                    <Select options={statusOptions} onChange={(e) => setMediaStatus({ ...MediaStatus, status: e.value })} defaultValue={{value:0,label:"Desactivate"}} />
                  </div>
                </div>
                <div style={{ paddingLeft: 10 }}>
                  <Button onClick={changeMediaStatus} className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp">
                    Apply
                  </Button>
                </div>
              </div>
            </Row>


          </Col>
        </Row>
      </Container>
    </>
  );
}

export default MediaList;
